import { MAX_JOB_PREFERENCES_FREE_TEXT_LENGTH } from '../constants';
import { UpdateJobPreferencesFormData, UpdateJobPreferencesFormErrors } from '../types';

export default function formValidate(formData: UpdateJobPreferencesFormData) {
    const errors: UpdateJobPreferencesFormErrors = {};

    if (!formData.freeText) {
        errors.freeText = 'Required';
    }

    if (formData.freeText && formData.freeText.length > MAX_JOB_PREFERENCES_FREE_TEXT_LENGTH) {
        errors.freeText = `Max length is ${ MAX_JOB_PREFERENCES_FREE_TEXT_LENGTH } characters`;
    }

    return errors.freeText ? errors : null;
}
